/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_No_Terms_Selected_ToastInputs */



/**
* | output |
* | --- |
* | "No terms selected" |
*
* @param {Knp_Lookup_No_Terms_Selected_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_no_terms_selected_toast = /** @type {((inputs?: Knp_Lookup_No_Terms_Selected_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_No_Terms_Selected_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun terme selectionne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Begriffe ausgewählt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun termine selezionato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Термины не выбраны")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay términos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未选择任何条款")
	if (locale === "ja") return /** @type {LocalizedString} */ ("用語が選択されていません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई पद चयनित नहीं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum termo selecionado")
	return /** @type {LocalizedString} */ ("No terms selected")
});